export const SUBMISSION_LIMITS = Object.freeze({
  standardPdfBytes: 2 * 1024 * 1024,
  attemptLifetimeMs: 30 * 24 * 3600 * 1000,
  leaseMs: 120_000,
});
/** The browser's random UUIDv4 attempt key, which is also its bearer capability. */
export const validAttemptId = (value: unknown): value is string => typeof value === 'string' && /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(value);
